<template>
  <div class="accordion-group">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="accordion-item"
      :class="{ 'no-auto-open': index > 0 }"
    >
      <div class="accordion-header">{{ item.q }}</div>
      <div class="accordion-content">
        <div class="accordion-content-inner">
          <p>{{ item.a }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqAccordion',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
